import { url } from '@octadesk-tech/services'

let cachedBaseURL = ''

export const initBeaconClient = async () =>
  (cachedBaseURL = await url.getAPIURL('widgetBff'))

export function getBeaconURL(roomKey) {
  if (!cachedBaseURL) {
    console.error('Base URL is null', cachedBaseURL)
    return null
  }

  if (!roomKey) {
    return null
  }

  return `${cachedBaseURL}/rooms/${roomKey}/schedule-room-close`
}
